<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}/articles`">Articles</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">{{ this.$store.state.article.title }}</a></li>
      </ul>
    </nav>

    <modal v-bind:visible="showModal" v-on:close="closeDeleteArticleModal">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="title is-4">Deleting article</p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-left">
              <span class="icon is-large has-text-danger"><i class="fa fa-3x fa-exclamation-triangle"></i></span>
            </div>
            <div class="media-content">
              <p>Are you sure you want to <strong>delete</strong> this article?</p>
              <p>This action cannot be undone.</p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" v-on:click="deleteItem">Delete</button>
          <button class="button is-light" v-on:click="closeDeleteArticleModal">Cancel</button>
        </footer>
      </div>
    </modal>

    <div class="columns">
      <div class="column is-8 is-offset-1">
        <p class="title is-4">{{ this.$store.state.article.title }}</p>
        <p><span class="has-text-grey">Article ID:</span> {{ this.$store.state.article.id }}</p>
        <p><span class="has-text-grey">Location:</span> {{ this.$store.state.article.location }}</p>
        <p><span class="has-text-grey">Created at:</span> {{ this.$store.state.article.created_at }}</p>
        <p><span class="has-text-grey">Updated at:</span> {{ this.$store.state.article.updated_at }}</p>
      </div>

      <div class="column is-2">
        <div class="field is-grouped">
          <div class="control">
            <router-link v-bind:to="`/clients/${this.$route.params.client_id}/articles/${this.$route.params.article_id}/edit`" class="button is-primary is-outlined">
              <span class="icon"><i class="fa fa-lg fa-pencil"></i></span>
              <span>Edit</span>
            </router-link>
          </div>
          <div class="control">
            <a v-on:click="openDeleteArticleModal" class="button is-danger is-outlined">
              <span class="icon"><i class="fa fa-lg fa-trash"></i></span>
              <span>Delete</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-8 is-offset-1">
        <article class="media">
          <figure v-if="this.$store.state.article.cover" class="media-left">
            <p><span class="has-text-grey">Cover:</span></p>
            <p class="image is-128x128">
              <img v-bind:src="`${apiUrl}/articles/covers/${this.$store.state.article.cover}?size=square`">
            </p>
          </figure>
          <div class="media-content">
            <div v-if="this.$store.state.article.content" class="content">
              <p><span class="has-text-grey">Content:</span></p>
              <p>{{ this.$store.state.article.content }}</p>
            </div>
            <div v-else class="content">
              <p><span class="has-text-grey">Link:</span></p>
              <p>{{ this.$store.state.article.link }}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import { Modal } from 'vue-bulma-modal'

  export default {
    data () {
      return {
        apiUrl: process.env.API_URL,
        showModal: false
      }
    },

    methods: {
      deleteItem () {
        this.showModal = false
        this.$store.dispatch('deleteArticle', this.$route.params.article_id)
          .then(() => {
            this.$router.push(`/clients/${this.$route.params.client_id}/articles`)
          })
          .catch(() => {
            // Simply don't redirect user anywhere
            this.$store.commit('SHOW_ERROR_BUBBLE', true)
          })
      },

      openDeleteArticleModal () {
        this.showModal = true
      },

      closeDeleteArticleModal () {
        this.showModal = false
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })

      this.$store.dispatch('getArticle', {
        articleId: this.$route.params.article_id
      })
    },

    components: {
      Modal
    }
  }
</script>

<style scoped>
  .modal-card-foot{
    justify-content: flex-end;
  }

  .tag.badge-owner {
    background-color: #FFA726;
    color: #fff;
  }

  .tag.badge-guest {
    background-color: #388E3C;
    color: #fff;
  }

  .tag.badge-invitee {
    background-color: #039BE5;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// ArticleView.vue?2f747831